import styled from "styled-components";

const Separator = styled.div`
  width: 100%;
  border-top: 1px solid #0a587e;
`;

export default Separator;
